import React from 'react';
import { priceFormat } from '../../../../util';
import { getItemNameAndQuantity } from '../helpers';
import * as toolSelectors from '../../../../selectors/tools';
import { useSelector } from 'react-redux';
import { ResultsColumn, ResultsColumnHeader, Row, HeaderRow, SubTitleText, Spreadsheet } from '../DTInfoWidget.styles';

const DTItemsForPartialRefundWidget = () => {
  const selectedLineItems = useSelector(toolSelectors.getSelectedLineItems);
  const orderingSystem = useSelector(toolSelectors.getOrderingSystem);

  if (selectedLineItems.length) {
    return (
      <Spreadsheet className="fs-block">
        <SubTitleText>SELECTED ITEMS</SubTitleText>
        <HeaderRow>
          <ResultsColumnHeader>ITEM</ResultsColumnHeader>
          <ResultsColumnHeader>PRICE</ResultsColumnHeader>
        </HeaderRow>
        {selectedLineItems.map((item) => (
          <Row key={JSON.stringify(item)} className="fs-block">
            <ResultsColumn>{getItemNameAndQuantity(item, orderingSystem)}</ResultsColumn>
            <ResultsColumn>{priceFormat(item.price)}</ResultsColumn>
          </Row>
        ))}
      </Spreadsheet>
    );
  }

  return null;
};
export default DTItemsForPartialRefundWidget;
